// Cloudinary image optimization utilities
export function getOptimizedImageUrl(originalUrl, useCase = 'display') {
    if (!originalUrl || !originalUrl.includes('cloudinary.com')) {
      return originalUrl; // Return original if not Cloudinary
    }
    
    // Different transformations for different use cases
    const transformations = {
      display: 'w_800,q_80',   // Good quality for display
      thumbnail: 'w_200,q_70', // Small thumbnails 
      drag: 'w_400,q_60'       // Lower quality for dragging
    };
    
    // Apply the appropriate transformation
    const transform = transformations[useCase] || transformations.display;
    
    // Check if the URL already has transformations
    if (originalUrl.includes('/upload/')) {
      return originalUrl.replace('/upload/', `/upload/${transform}/`);
    }
    
    return originalUrl; // If URL structure is unexpected, return original
  }
  
  // Convert RGB color to hex
  export function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }
  
  // Convert hex to RGB
  export function hexToRgb(hex) {
    // Remove the hash at the beginning if it's there
    hex = hex.replace(/^#/, '');
  
    // Parse the hex value
    const bigint = parseInt(hex, 16);
    
    // Extract R, G, and B components
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
  
    return { r, g, b };
  }
  
  // Create a color with some transparency
  export function createTransparentColor(color, opacity = 0.7) {
    const rgbColor = hexToRgb(color);
    return `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, ${opacity})`;
  }
  
  // Format dimensions for display
  export function formatDimensions(width, height, unit = 'inches') {
    return `${width}" × ${height}" ${unit}`;
  }// Convert inches to feet
